export type ResourceLink = {
  label: string
  url: string
}

export type ResourceCategory = {
  id: string
  title: string
  intro: string
  links: ResourceLink[]
}

export const resourceCategories: ResourceCategory[] = [
  {
    id: 'bedrijfsprofielen',
    title: 'Bedrijfsprofielen & Citations',
    intro:
      'Zakelijke profielen waarop de naam, het adres en de contactgegevens van Goelst International B.V. worden vermeld. Deze vermeldingen houden onze bedrijfsgegevens consistent op het web.',
    links: [
      { label: 'Acompio Nederland', url: 'https://www.acompio.nl/Goelst-International-BV-47826870.html' },
      { label: 'Addonbiz', url: 'https://www.addonbiz.com/listing/modemweg-19-amersfoort-utrecht-3821-bs-goelst-international-b-v/' },
      { label: 'Best Deal Finder', url: 'http://www.bestdealfinder.com/netherlands/amersfoort/professional-services/goelst-international-b-v' },
      { label: 'Bestincom', url: 'https://www.bestincom.com/amersfoort/manufacturing/goelst-international-b-v' },
      { label: 'Birdeye', url: 'https://reviews.birdeye.com/goelst-international-bv-178910075909647' },
      { label: 'Biz Bang Boom', url: 'https://www.bizbangboom.com/amersfoort/business-services/goelst-international-b-v' },
      { label: 'Bizcoupon Directory', url: 'https://www.bizcoupon.directory/netherlands/amersfoort/business-services/goelst-international-b-v' },
      { label: 'Biz Ratings', url: 'https://www.bizratings.com/Goelst-International-BV-124899' },
      { label: 'Blinx Biz', url: 'https://www.blinx.biz/goelst-international-bv' },
      { label: 'Brownbook', url: 'https://www.brownbook.net/business/55495271/goelst-international-bv' },
      { label: 'Business Listing Plus', url: 'https://businesslistingplus.com/profile/httpsgoelst-internationalcom/' },
      { label: 'City Best Awards', url: 'https://citybestawards.com/biz/goelst-international-b-v' },
      { label: 'Colist Europe', url: 'https://www.colist.eu/compover.php?comp_id=1698&lang=en&cook_land=38&xc=1' },
      { label: 'Cybo', url: 'https://www.cybo.com/NL-biz/goelst-international-b-v' },
      { label: 'Directory9', url: 'https://directory9.net/listing/goelst-international-bv.html' },
      { label: 'eCityBiz', url: 'https://www.ecitybiz.com/listing/goelst-international-bv.html' },
      { label: 'Enroll Business Nederland', url: 'https://nl.enrollbusiness.com/BusinessProfile/7958967' },
      { label: 'Express Business Directory', url: 'https://www.expressbusinessdirectory.com/directory/goelst-international-b-v/' },
      { label: 'Flokii', url: 'https://flokii.com/businesses/view/164690/goelst-international-b-v' },
      { label: 'Globale Connections', url: 'https://www.globaleconnections.com/netherlands/amersfoort/professionals/goelst-international-b-v' },
      { label: 'Hotfrog Nederland', url: 'https://www.hotfrog.nl/company/86175d3692da6fe65ee0e4c0c17af9a2/goelst-international-b-v/amersfoort/business-organizations' },
      { label: 'IBI Directories', url: 'https://www.ibidirectories.com/netherlands/amersfoort/ibi-categories/goelst-international-b-v' },
      { label: 'iFormative', url: 'https://www.iformative.com/product/goelst-international-bv-p3138429.html' },
      { label: 'Isokori Gari Directory', url: 'https://www.isokorigaridirectory.com/amersfoort/business-support-services/goelst-international-b-v' },
      { label: "Let's Know It", url: 'https://letsknowit.com/goelst183345' },
      { label: 'Marktnet', url: 'https://www.marktnet.nl/diensten/overige-diensten/goelst-international-b-v-96653077.htm' },
      { label: 'Nederland in Bedrijf', url: 'https://www.nederlandinbedrijf.nl/Bedrijf/977057/Zakelijke-dienstverlening-Goelst-International-B.V./Modemweg-19-3821BS-Amersfoort-0333035964' },
      { label: 'ProvenExpert', url: 'https://www.provenexpert.com/goelst-international-b-v/?mode=preview' },
      { label: 'Startupxplore', url: 'https://startupxplore.com/en/startups/goelst-international-b-v' },
      { label: 'Success Center', url: 'https://www.successcenter.com/amersfoort/product/goelst-international-b-v' },
      { label: 'Surf Your Town', url: 'https://www.surfyourtown.com/amersfoort/business-services/goelst-international-b-v' },
      { label: 'Top SEO Brands', url: 'https://www.topseobrands.com/profile/goelst-international-b-v' },
      { label: 'Trueen', url: 'https://trueen.com/business/listing/goelst-international-b-v/795997' },
      { label: 'Trustindex', url: 'https://www.trustindex.io/reviews/goelst-international.com-1' },
      { label: 'Verview', url: 'https://verview.com/biz/10101787-goelst-international-bv-amersfoort-utrecht' },
      { label: 'Warrior Biz Network', url: 'https://www.warriorbiznetwork.com/netherlands/amersfoort/retail/goelst-international-b-v' },
      { label: 'We Got A Guy', url: 'https://www.wegotaguy.net/local-business-services/amersfoort/utrecht/goelst-international-b-v' },
      { label: 'Wireanium', url: 'https://www.wireanium.com/netherlands/amersfoort/business-consultants/goelst-international-b-v' },
      { label: 'Youbiz', url: 'https://www.youbiz.com/listing/goelst-international-bv.html' },
    ],
  },
  {
    id: 'kaarten-lokaal',
    title: 'Kaarten & Lokale Vermeldingen',
    intro:
      'Lokale gidsen en kaartvermeldingen voor onze vestiging aan de Modemweg 19 in Amersfoort. Handig om onze locatie, openingstijden en telefoonnummer te controleren.',
    links: [
      { label: 'AskMap', url: 'http://www.askmap.net/location/7942166/netherlands/goelst-international-b.v.' },
      { label: 'InfoisInfo Amersfoort', url: 'https://amersfoort.infoisinfo.nl/kaart/goelst-international-b-v/1076523' },
      { label: 'Locally', url: 'https://www.locally.com/store/515016/preview' },
      { label: 'Locanto Amersfoort', url: 'https://www.locanto.nl/amersfoort/ID_9422685876/Goelst-International-B-V.html' },
      { label: 'MisterWhat Nederland', url: 'https://www.misterwhat.nl/company/637073-goelst-international-bv-amersfoort' },
      { label: 'Nearfinder Nederland', url: 'https://nearfindernl.com/nl/business/ut/amersfoort/categorie_bedrijf-en-professionele-diensten/goelst-international-b-v_1611193+8.html' },
      { label: 'Nextdoor Amersfoort', url: 'https://nextdoor.nl/page/goelst-international-bv-amersfoort-ut' },
      { label: 'Openingstijden.com', url: 'https://www.openingstijden.com/o10035120/goelst-international-b.v.-modemweg-19-amersfoort/' },
      { label: 'Pages24 Amersfoort', url: 'https://www.pages24.nl/amersfoort/goelst-international-bv-aYGj6G.html' },
      { label: 'Place123', url: 'http://www.place123.net/place/goelst-international-b.v.-amersfoort-netherlands' },
      { label: 'Scribble Maps', url: 'https://www.scribblemaps.com/maps/view/Goelst-International-BV/goelstinternationalnl' },
      { label: 'Telefoonboek.nl', url: 'https://www.telefoonboek.nl/bedrijven/t10035120/amersfoort/goelst-international-b.v./' },
      { label: 'Tellows Nederland', url: 'https://www.tellows.nl/num/%2B31333035964' },
      { label: 'Tupalo Amersfoort', url: 'https://www.tupalo.nl/amersfoort/goelst-international-b-v' },
      { label: 'Wanderboat', url: 'https://wanderboat.ai/posts/goelst-international-b.v./GLOjeeTsRIutatBYFXBFKg' },
      { label: "What's Your Hours", url: 'https://www.whatsyourhours.com/netherlands/amersfoort/business-services/goelst-international-b-v' },
      { label: 'Where2Go', url: 'https://where2go.com/binn/b_search.w2g?function=detail&type=quick&listing_no=2220113&_UserReference=7F000001465584B039013951D1736AA4F0E0' },
      { label: 'YP Local', url: 'https://www.yplocal.com/netherlands/amersfoort/business-professional-services/goelst-international-b-v' },
      { label: 'ZeeMaps', url: 'https://www.zeemaps.com/map/oqsdy?group=7166404' },
    ],
  },
  {
    id: 'sociaal-media',
    title: 'Sociale & Media Profielen',
    intro:
      'Kanalen waarop wij publicaties, presentaties en achtergrondinformatie over gordijnrailsystemen delen. Ons officiële socialekanaal is Instagram.',
    links: [
      { label: 'Instagram — @goelst_international', url: 'https://www.instagram.com/goelst_international/' },
      { label: '4mark', url: 'https://4mark.net/e950mmjqdovz/goelst-international-bv' },
      { label: 'AnyFlip', url: 'https://anyflip.com/homepage/vdtdj#About' },
      { label: 'Art Jobs', url: 'https://www.artjobs.com/users/goelstinternationalnl' },
      { label: 'Atlas Obscura', url: 'https://www.atlasobscura.com/users/goelst-international-bv' },
      { label: 'Blurb', url: 'https://www.blurb.com/user/goelstinter?profile_preview=true' },
      { label: 'Disqus', url: 'https://disqus.com/by/goelstinternationalbv/about/' },
      { label: 'Dreevoo', url: 'https://dreevoo.com/profile_info.php?pid=2353661' },
      { label: 'Experiment', url: 'https://experiment.com/users/goelstinternationalnl' },
      { label: 'Issuu', url: 'https://issuu.com/goelstinternationalnl' },
      { label: 'JustPaste.it', url: 'https://justpaste.it/goelstinternationalnl' },
      { label: 'Medium — artikel', url: 'https://medium.com/@goelstinternationalnl/goelst-international-b-v-89acbe843f20' },
      { label: 'Penzu', url: 'https://penzu.com/public/dfbf3235dbe2c674' },
      { label: 'ReleaseWire', url: 'https://connect.releasewire.com/company/goelst-international-bv-361512.htm' },
      { label: 'Speaker Deck', url: 'https://speakerdeck.com/goelstinternationalnl' },
      { label: 'Storeboard', url: 'https://www.storeboard.com/goelstinternationalbv' },
      { label: 'Wakelet', url: 'https://wakelet.com/@GoelstInternationalBV69068' },
      { label: 'Yoomark', url: 'https://yoomark.com/content/address-modemweg-19-amersfoort-utrecht-3821-bs-phone-0031-033-303-5964-business-email' },
    ],
  },
  {
    id: 'overige-bronnen',
    title: 'Overige Zakelijke Bronnen',
    intro:
      'B2B-platforms, leveranciersoverzichten, contactpagina\'s en verzamelpagina\'s met onze gegevens. Vooral relevant voor inkopers, projectpartners en installateurs.',
    links: [
      { label: 'Europages Nederland', url: 'https://www.europages.nl/nl/company/goelst-international-bv-22416301' },
      { label: 'B2BCO', url: 'https://www.b2bco.com/goelstinternationalnl/' },
      { label: 'EC21', url: 'https://goelstinternationaln.en.ec21.com/' },
      { label: 'Dealer Baba', url: 'https://www.dealerbaba.com/suppliers/goelst-international-bv-mtwk4m3t' },
      { label: 'Trepup', url: 'https://www.trepup.com/store/goelstinternation/profile' },
      { label: 'Supply Autonomy', url: 'https://supplyautonomy.com/goelstinternational.nl' },
      { label: 'Wielevert — leveranciers', url: 'https://www.wielevert.nl/leveranciers/goelst-international-b-v-id582965.html' },
      { label: 'DiBiz', url: 'https://www.dibiz.com/goelstinternationalnl' },
      { label: 'LinkCentre', url: 'https://www.linkcentre.com/profile/goelstinternationalb/' },
      { label: 'FlowCV', url: 'https://flowcv.com/resume/a6viijpadfbg' },
      { label: 'Bio.so', url: 'https://bio.so/goelstinternationalnl/' },
      { label: 'Taplink', url: 'https://goelstinternationalnl.taplink.site/' },
      { label: 'Lnk.Bio', url: 'https://lnk.bio/goelstinternationalnl' },
      { label: 'Onee.page', url: 'https://onee.page/goelstinternationalnl' },
      { label: 'Shor.by', url: 'https://shor.by/goelstinternationalnl' },
      { label: 'Solo.to', url: 'https://solo.to/goelstinternationaln' },
      { label: 'Zumvu', url: 'https://zumvu.com/goelstinternationalnl/' },
      { label: 'Reservio — contactpagina', url: 'https://goelst-international-b-v.reservio.com/' },
      { label: 'Setmore — contactpagina', url: 'https://goelstinternationalbv.setmore.com/' },
      { label: 'SimplyBook — contactpagina', url: 'https://goelstinternationalnl.simplybook.it/v2/' },
    ],
  },
]

export const totalResourceLinks = resourceCategories.reduce(
  (sum, category) => sum + category.links.length,
  0,
)
